import { useState } from "react";
import { Button, Typography, Space } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const { Text } = Typography;

const SecretDisplay = ({ merchantData }) => {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  // Get the first secret
  const secret =
    merchantData?.terminalRole?.data?.secrets?.[0] ?? t("noSecretFound");

  return (
    <Space align="center">
      <h4>{t("secretKey")}: </h4>
      <Text code>{visible ? secret : "••••••••"}</Text>
      <Button
        icon={visible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
        onClick={() => setVisible(!visible)}
        size="small"
      />
    </Space>
  );
};

export default SecretDisplay;
